(function(){
'use strict';
const gallery = [
  {src:window.SnapLockAssets?.using, alt:'SnapLock sealing a compatible snack bag'},
  {src:window.SnapLockAssets?.white, alt:'White SnapLock reference photograph'},
  {src:window.SnapLockAssets?.blue, alt:'Navy SnapLock reference photograph'},
  {src:window.SnapLockAssets?.cutter, alt:'Integrated SnapLock cutter in use'},
  {src:window.SnapLockAssets?.fridge, alt:'SnapLock magnetic fridge storage'},
  {src:window.SnapLockAssets?.charging, alt:'SnapLock USB-C charging'},
  {src:window.SnapLockAssets?.size, alt:'Original SnapLock dimensions'},
  {src:window.SnapLockAssets?.modes, alt:'SnapLock sealing levels P1–P6'}
].filter(x=>x.src);
function money(cents,currency){
 const code=currency||'DKK';
 try { return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:code}).format(cents/100); }
 catch(e){ return (cents/100).toFixed(2)+' '+code; }
}
function init(section){
 if(!section||section.dataset.slReady==='true') return;
 section.dataset.slReady='true';
 let index=0;
 const $=s=>section.querySelector(s);
 const image=$('#mainImage');const thumbs=$('#thumbs');
 const lightbox=$('#lightbox');
 const qtyRadios=section.querySelectorAll('input[name="quantity"]');
 const variantSelect=$('[data-variant-select]');
 const variantsTag=$('[data-variants-json]');
 const variants=variantsTag?JSON.parse(variantsTag.textContent):[];
 const productForm=$('form.sl-product-form');
 const price=$('#priceDisplay'),compare=$('#oldPriceDisplay'),discount=$('#saleDisplay');
 const status=$('[data-variant-status]');
 const mobilePrice=$('[data-mobile-price]'),mobileBuy=$('#mobileCart');
 const variantCurrency=section.dataset.currency||'DKK';
 const updateGallery=()=>{
  if(!image||!thumbs||!gallery.length)return;
  const p=gallery[index];image.src=p.src;image.alt=p.alt;image.style.objectFit=index===0?'cover':'contain';
  thumbs.innerHTML=gallery.map((f,i)=>'<button type="button" class="thumb '+(i===index?'active':'')+'" data-index="'+i+'" aria-label="'+((window.SnapLockI18n||{}).viewImage||'View product image')+' '+(i+1)+'" aria-current="'+(i===index)+'"><img loading="lazy" width="88" height="88" src="'+f.src+'" alt=""></button>').join('');
 };
 const showImage=n=>{index=(n+gallery.length)%gallery.length;updateGallery()};
 thumbs?.addEventListener('click',ev=>{const b=ev.target.closest('[data-index]');if(b)showImage(Number(b.dataset.index))});
 $('#prevImage')?.addEventListener('click',()=>showImage(index-1));
 $('#nextImage')?.addEventListener('click',()=>showImage(index+1));
 let touch=null;
 const frame=$('#galleryFrame');
 frame?.addEventListener('touchstart',ev=>{touch=ev.changedTouches[0].screenX},{passive:true});
 frame?.addEventListener('touchend',ev=>{if(touch===null)return;const dx=ev.changedTouches[0].screenX-touch;if(Math.abs(dx)>50)showImage(index+(dx<0?1:-1));touch=null},{passive:true});
 $('#openZoom')?.addEventListener('click',()=>{if(!lightbox)return;const zoom=$('#zoomImage');zoom.src=gallery[index].src;zoom.alt=gallery[index].alt;lightbox.classList.add('open');document.body.style.overflow='hidden';$('#closeZoom')?.focus()});
 const closeZoom=()=>{lightbox?.classList.remove('open');document.body.style.overflow=''};
 $('#closeZoom')?.addEventListener('click',closeZoom);
 lightbox?.addEventListener('click',e=>{if(e.target===lightbox)closeZoom()});
 const esc=e=>{if(e.key==='Escape')closeZoom()};window.addEventListener('keydown',esc);
 const variant=()=>variants.find(v=>String(v.id)===String(variantSelect?.value||$('[data-variant-id]')?.value||''));
 const quantity=()=>{const checked=section.querySelector('input[name="quantity"]:checked');return Number(checked?.value||1)};
 const update=()=>{
  qtyRadios.forEach(r=>r.closest('.pack')?.classList.toggle('checked',r.checked));
  const v=variant();if(!v)return;
  const total=v.price*quantity();
  if(price)price.textContent=money(total,variantCurrency);
  if(mobilePrice)mobilePrice.textContent=money(total,variantCurrency);
  if(compare&&discount){
   const hasCompare=v.compare_at_price&&v.compare_at_price>v.price;
   compare.hidden=!hasCompare;discount.hidden=!hasCompare;
   if(hasCompare){compare.textContent=money(v.compare_at_price*quantity(),variantCurrency);discount.textContent=((window.SnapLockI18n||{}).save||'Save')+' '+Math.round(100*(v.compare_at_price-v.price)/v.compare_at_price)+'%';}
  }
  const submit=productForm?.querySelector('[type="submit"]');if(submit&&!submit.dataset.label&&!submit.disabled)submit.dataset.label=submit.textContent;if(mobileBuy&&!mobileBuy.dataset.label&&!mobileBuy.disabled)mobileBuy.dataset.label=mobileBuy.textContent;
  if(submit){submit.disabled=!v.available;submit.textContent=v.available?(submit.dataset.label||'ADD TO CART →'):(window.SnapLockI18n||{}).soldOut||'SOLD OUT';}
  if(mobileBuy){mobileBuy.disabled=!v.available;mobileBuy.textContent=v.available?(mobileBuy.dataset.label||'ADD TO CART →'):(window.SnapLockI18n||{}).soldOut||'SOLD OUT';}
  if(status)status.textContent=v.available?'':(window.SnapLockI18n||{}).unavailable||'This variant is currently unavailable.';
  // If selected option is clearly blue/white, show matching reference photo.
  const title=(v.title||'').toLowerCase();
  if(/navy|blue|blå/.test(title))showImage(2);
  else if(/white|hvid/.test(title))showImage(1);
 };
 variantSelect?.addEventListener('change',update);
 qtyRadios.forEach(r=>r.addEventListener('change',update));
 mobileBuy?.addEventListener('click',()=>{if(productForm&&typeof productForm.requestSubmit==='function'){productForm.requestSubmit()}else{document.querySelector('#product')?.scrollIntoView({behavior:'smooth'})}});
 updateGallery();update();
 section.querySelectorAll('.mode-button').forEach(b=>b.addEventListener('click',()=>section.querySelectorAll('.mode-button').forEach(v=>v.setAttribute('aria-pressed',String(v===b)))));
}
function load(){document.querySelectorAll('[data-snaplock-product]').forEach(init)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',load);else load();
document.addEventListener('shopify:section:load',load);
document.addEventListener('click', e=>{const b=e.target.closest('.mode-button');if(!b)return;const group=b.closest('.mode-copy')||document;b.parentElement.querySelectorAll('.mode-button').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));});
})();